module.exports = __webpack_public_path__ + "img/Image_10.23519eb6.png";